
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type MessagingSendMessage201AllOfOnezeroMediaLinksItemLinkType = typeof MessagingSendMessage201AllOfOnezeroMediaLinksItemLinkType[keyof typeof MessagingSendMessage201AllOfOnezeroMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessagingSendMessage201AllOfOnezeroMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
